import { registerComponent } from '@gig/magic-common';
import ModalComponent from './modal.vue.js';

var Modal = registerComponent(ModalComponent);

export { Modal };
